import {lazy} from 'react';

export const ReportsDashboard = lazy(() => import('./dashboard'));
export const CreateReport = lazy(() => import('./createReport'));
export const ReportTemplate = lazy(() => import('./reportTemplate'));
